import { Component, OnInit } from '@angular/core';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { AzureAuthService } from 'src/service/azure-auth.service';

@Component({
  selector: 'basic',
  templateUrl: 'basicLayout.template.html',
})
export class BasicLayoutComponent implements OnInit  {

  public isNavigationOpen = false;

  constructor(
    public app: ApplicationConfigService,
    public azureAuthService: AzureAuthService
  ) {
  }

  ngOnInit() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-small');

    this.azureAuthService.onInit();
  }

  onResize() {
  }

  onNavigationToggle(bool: boolean): void {
    const body = document.getElementsByTagName('body')[0];
    if (bool) {
      body.classList.add('mini-navbar');
    } else {
      body.classList.remove('mini-navbar');
    }
  }
}
